import React from 'react';
import { View } from 'react-native';
import Gradient, { Direction } from 'rgt';

import { Body1, Body2, H1, H2 } from '@src/components/Typography';

import { Props } from './types';

type Start = Props['start'];
type End = Props['end'];

const directionResolver = (start: Start, end: End): Direction => {
  if (!start || !end) {
    return 'left-to-right';
  }

  const isRtl = start.x - end.x >= 0;
  const isTopToBottom = start.y - end.y >= 0;

  if (isRtl) {
    return 'right-to-left';
  } else if (!isRtl) {
    return 'left-to-right';
  } else if (isTopToBottom) {
    return 'top-to-bottom';
  } else if (!isTopToBottom) {
    return 'bottom-to-top';
  } else {
    return 'left-to-right';
  }
};

const GradientText: React.FC<Props> = ({
  start,
  end,
  startColor,
  endColor,
  textType = 'h1',
  children,
  ...props
}) => {
  let TextComponent;
  switch (textType) {
    case 'body1':
      TextComponent = Body1;
      break;
    case 'body2':
      TextComponent = Body2;
      break;
    case 'h1':
      TextComponent = H1;
      break;
    case 'h2':
      TextComponent = H2;
      break;
  }

  return (
    <View>
      <TextComponent {...props} style={[props.style, { fontWeight: 'bold' }]}>
        <Gradient
          from={startColor}
          to={endColor}
          dir={directionResolver(start, end)}
        >
          {children}
        </Gradient>
      </TextComponent>
    </View>
  );
};

export default React.memo(GradientText);
